//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionAxisExtrapolationModeBuilder.js";
import "../CAM/CAM.InspectionCylinderCircleFitModeBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AxisDirectionI",1,0],[0,"AxisDirectionJ",1,0],[0,"AxisDirectionK",1,0],[1,"AxisExtrapolationModeBuilder",0,"CAM.InspectionAxisExtrapolationModeBuilder",0],[0,"AxisVector",1,"Direction",0],[0,"CsysReferenceType",1,0],[1,"CylinderCircleFitModeBuilder",0,"CAM.InspectionCylinderCircleFitModeBuilder",0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"ExtentType",1,0],[0,"IncludedAngle",1,0],[0,"InnerOuterType",1,0],[0,"Name",1,0],[1,"SelectedCone",0,"SelectNXObject",0],[0,"VertexPointX",1,0],[0,"VertexPointY",1,0],[0,"VertexPointZ",1,0]],[[[],"UpdateParams",{},0,0]],[]];
SPLM.CAM.InspectionConeFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionConeFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;